import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ImportPayments from "@/components/app/ImportPayments.vue";
import CreatePayments from "@/components/app/CreatePayments.vue";
import ListPaymentsTable from "@/components/app/ListPaymentsTable.vue";
import {PaymentType} from "@/components/blocks/Types";
import {ref} from "vue";

// Define components ref

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsView',
  setup(__props) {


const paymentTable = ref()

// Define function
function handleNewPayments(items: PaymentType[]) {
  console.log('New payments added', items)
  paymentTable.value.loadData()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ImportPayments, { onNewPayments: handleNewPayments }),
    _createVNode(CreatePayments, { onNewPayment: handleNewPayments }),
    _createVNode(ListPaymentsTable, {
      ref_key: "paymentTable",
      ref: paymentTable
    }, null, 512)
  ], 64))
}
}

})